/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Range,
  LoggerEnumType,
  InverterV2,
} from '..';
import {
  serializeRange,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetInverterDataByRangeV2Input {
  serial: string;
  range: Range;
  type?: LoggerEnumType;
}
const build = (_query: DocumentNode, input: GetInverterDataByRangeV2Input, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.serial !== undefined ? `$serial: String = ${JSON.stringify(input.serial).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.range !== undefined ? `$range: Range = ${serializeRange(input.range)}, ` : '' ) + ``+
    ( input.type !== undefined ? `$type: LoggerEnumType = ${input.type}` : '' ) + `){
    getInverterDataByRangeV2(
      ${ input.serial !== undefined ? 'serial: $serial,' : '' } 
      ${ input.range !== undefined ? 'range: $range,' : '' } 
      ${ input.type !== undefined ? 'type: $type,' : '' }
    ){
      ...inverterv2
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetInverterDataByRangeV2Query {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment inverterv2 on InverterV2 { ... }
   */
  async execute(_query: DocumentNode, input: GetInverterDataByRangeV2Input, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getInverterDataByRangeV2: Partial<InverterV2>[] }>({ query: build(_query, input), fetchPolicy });
  }
}
